import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseEstablishmentUserExternalTokensProps<T> = {
  filters: {
    establishmentUserId?: string;
    page?: number;
    search?: string;
  },
  mapper?: (data: any) => T;
};

const useEstablishmentUserExternalTokens = <T,>({
  filters: { page, search, establishmentUserId },
  mapper = Mapper.default<T>(),
}: UseEstablishmentUserExternalTokensProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    enabled: !!establishmentUserId,
    queryKey: ['establishmentUserExtenalTokens', establishmentUserId],
    queryFn: () => {
      return privateAxios.get(`/establishment/user_external_tokens`, {
        params: {
          search,
          page,
          "q[user_id_eq]": establishmentUserId,
        },
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, isPending, ...rest };
};

export default useEstablishmentUserExternalTokens;
